Whether the signal associates with a successful state.

For application status updates, a value of `true` indicates the candidate was successful, and `false` indicates the candidate was unsuccessful.

For position status updates, a value of `true` indicates the position was filled, and `false` indicates it was not (and will not).

A `status` of null is treated as neither successful nor unsuccessful, meaning the application or position is still progressing.
